import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import PCHome from '@/views/pc/home.vue'
import MHome from '@/views/m/home.vue'

import { IsPC as IsPC } from '@/utils/util'

Vue.use(VueRouter)

// if(window.location.host == 'zzcl.kjcxchina.com'){
//   indexUrl = '../views/pc/index.vue'
// }
// if(window.location.host=='jt.zzcl.kjcxchina.com'){
//   indexUrl = '../views/pc/group_index.vue'
//   // @/views/pc/group_index.vue
// }

const routes_pc = [
  {
    path: '*',
    redirect: '/'
  },

  {
    path: '/',
    name: 'PCHome',
    component: PCHome,
    children: [
      //首页
      {
        path: '/',
        name: 'Index',
        component: () => import('@/views/pc/index.vue'),
        meta: {
          topState: true
        }
      }, {
        path: '/newsList',
        name: 'NewsList',
        component: () => import('@/views/pc/list.vue'),
        meta: {
          topState: true,
          type: 1
        }
      }, {
        path: '/companyList',
        name: 'companyList',
        component: () => import('@/views/pc/list.vue'),
        meta: {
          topState: true,
          type: 1
        }
      }, {
        path: '/filesList',
        name: 'filesList',
        component: () => import('@/views/pc/list.vue'),
        meta: {
          topState: true,
          type: 2
        }
      }, {
        path: '/detail/:id',
        name: 'detail',
        component: () => import('@/views/pc/detail.vue'),
        meta: {
          topState: true
        }
      }, {
        path: '/claimTrain',
        name: 'claimTrain',
        component: () => import('@/views/pc/claimTrain.vue'),
        meta: {
          topState: true
        }
      }, {
        path: '/claimStatistics',
        name: 'claimStatistics',
        component: () => import('@/views/pc/claimStatistics.vue'),
        meta: {
          topState: true
        }
      }, {
        path: '/claimDemand',
        name: 'claimDemand',
        component: () => import('@/views/pc/claimDemand.vue'),
        meta: {
          topState: true
        }
      }, {
        path: '/claimSpecial',
        name: 'claimSpecial',
        component: () => import('@/views/pc/claimSpecial.vue'),
        meta: {
          topState: true
        }
      }, {
        path: '/claimList',
        name: 'claimList',
        component: () => import('@/views/pc/claimList.vue'),
        meta: {
          topState: true
        }
      }, {
        path: '/formIndex/qyrz_form',
        name: 'qyrz',
        component: () => import('@/views/pc/formIndex/qyrz_form.vue'),
        meta: {
          topState: true,
          title: '企业入驻信息表'
        }
      }, {
        path: '/formIndex/qyxq_form',
        name: 'qyxq',
        component: () => import('@/views/pc/formIndex/qyxq_form.vue'),
        meta: {
          topState: true,
          title: '企业需求提报信息表'
        }
      }, {
        path: '/formIndex/lmrc_form',
        name: 'lmrc',
        component: () => import('@/views/pc/formIndex/lmrc_form.vue'),
        meta: {
          topState: true,
          title: '劳模工匠人才入驻人员信息表'
        }
      }, {
        path: '/formIndex/lmfw_form',
        name: 'lmfw',
        component: () => import('@/views/pc/formIndex/lmfw_form.vue'),
        meta: {
          topState: true,
          title: '劳模工匠服务队信息表'
        }
      }, {
        path: '/formIndex/fwal_form',
        name: 'fwal',
        component: () => import('@/views/pc/formIndex/fwal_form.vue'),
        meta: {
          topState: true,
          title: '服务队案例信息表'
        }
      }, {
        path: '/formIndex/yyhd_form',
        name: 'fwal',
        component: () => import('@/views/pc/formIndex/yyhd_form.vue'),
        meta: {
          topState: true,
          title: '运营活动参与申报表'
        }
      }, {
        path: '/serviceItems',
        name: 'ServiceItems',
        component: () => import('@/views/pc/serviceItems.vue'),
        meta: {
          topState: true,
          title: '服务项目'
        }
      }, {
        path: '/serviceInfo',
        name: 'serviceInfo',
        component: () => import('@/views/pc/serviceInfo.vue'),
        meta: {
          topState: true,
          title: '服务项目'
        }
      }, {
        path: '/studyItems',
        name: 'StudyItems',
        component: () => import('@/views/pc/studyItems.vue'),
        meta: {
          topState: true,
          title: '课程板块'
        }
      }, {
        path: '/technicalTeam',
        name: 'TechnicalTeam',
        component: () => import('@/views/pc/technicalTeam.vue'),
        meta: {
          topState: true,
          title: '技术服务队'
        }
      }, {
        path: '/technicalInfo',
        name: 'technicalInfo',
        component: () => import('@/views/pc/technicalInfo.vue'),
        meta: {
          topState: true,
          title: '技术服务队'
        }
      }
    ]
  }
]
const routes_m = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'mHome',
    component: MHome,
    children: [
      //首页
      {
        path: '/',
        name: 'Index',
        component: () => import('@/views/m/index.vue'),
        meta: {
          headerIsShow: false,
        }
      }, {
        path: '/courseList',
        name: 'courseList',
        component: () => import('@/views/m/courseList.vue'),
        meta: {
        }
      }, {
        path: '/activityList',
        name: 'activityList',
        component: () => import('@/views/m/activityList.vue'),
        meta: {
        }
      }, {
        path: '/activityDetail',
        name: 'activityDetail',
        component: () => import('@/views/m/activityDetail.vue'),
        meta: {
          // headerIsShow:true,
        }
      },

    ]
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: IsPC() ? routes_pc : routes_m
  // routes: routes_pc 
})

export default router
